import { render, staticRenderFns } from "./getCodeLogin.vue?vue&type=template&id=6f393e0f&scoped=true&"
import script from "./getCodeLogin.vue?vue&type=script&lang=js&"
export * from "./getCodeLogin.vue?vue&type=script&lang=js&"
import style0 from "./getCodeLogin.vue?vue&type=style&index=0&id=6f393e0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f393e0f",
  null
  
)

export default component.exports